if (!window.__MY_KIT_TAB_ID__) {
    const id =
        (typeof crypto !== "undefined" && crypto.randomUUID)
            ? crypto.randomUUID()
            : `tab-${Math.random().toString(36).slice(2)}`;
    window.__MY_KIT_TAB_ID__ = id;
    try { sessionStorage.setItem("MY_KIT_TAB_ID", id); } catch {}
}
